const Patient = () => import(/* webpackChunkName: "pasien" */ '@/views/private/patient/Index.vue')
const General = () => import(/* webpackChunkName: "pasiengeneral" */ '@/views/private/patient/General.vue')
const PatientGeneral = () => import(/* webpackChunkName: "pasiengeneralindex" */ '@/components/general/Index.vue')
const PatientSupport = () => import(/* webpackChunkName: "pasiengeneralsupport" */ '@/components/general/Support.vue')
const Invoice = () => import(/* webpackChunkName: "pasien" */ '@/views/private/patient/invoice/Index.vue')
const PregnantAge = () => import(/* webpackChunkName: "pregnantage" */ '@/views/private/patient/pregnantage/Index.vue')

const Visit = () => import(/* webpackChunkName: "pregnantage" */ '@/views/private/patient/visit/index.vue')

const routes = [
  {
    path: "/patient",
    name: "patient",
    component: Patient,
    meta: {
      title: "Data Pasien"
    }
  },
  {
    path: "/patient/general",
    name: "patient general",
    component: General,
    meta: {
      title: "Data Pasien"
    },
    children: [
      {
        path: '/patient/general/main',
        name: ' patient general main',
        component: PatientGeneral,
        meta: {
          title: "Form Data Pasien"
        }
      },
      {
        path: '/patient/general/support',
        name: ' patient general support',
        component: PatientSupport,
        meta: {
          title: "Form Pendukung Data Pasien"
        }
      },
    ]
  },
  {
    path: "/patient/invoice",
    name: "patient invoice",
    component: Invoice,
    meta: {
      title: "Data Invoice Pasien"
    }
  },
  {
    path: "/patient/report-pregnant-age",
    name: "patient report pregnant age",
    component: PregnantAge,
    meta: {
      title: "Laporan Umur Kehamilan"
    }
  },
  {
    path: "/patient/report-visit",
    name: "patient report visit",
    component: Visit,
    meta: {
      title: "Laporan Kunjungan"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})